import React from "react";
import BulkSMS from "../../Component/Products/BulkSMS";

const MainBulkSMS = () => {
	return <BulkSMS />;
};

export default MainBulkSMS;
